import createCache from "@emotion/cache";

const createEmotionCache = () => {
  return createCache({
    key: "bfin",
    prepend: true,
  });
};

export default createEmotionCache;
